import { Button, Form, Input } from 'antd'
import { Flex, WhiteSpace, WingBlank } from 'antd-mobile'
import { Captcha, OTP, PhoneInput } from 'components'
import queryString from 'query-string'
import React from 'react'
import { Helmet } from 'react-helmet'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { removeCaptcha } from 'store/siteConfig'
import { intl } from 'utils'
import messages from './messages'
import classes from './styles.module.scss'

class MessagePay extends React.Component {
  constructor(props) {
    super(props)
    const params = queryString.parse(location.search)
    this.state = {
      orderToken: params.ft,
      loading: false,
    }
  }

    handleSubmit = () => {
      this.props.form.validateFields((errors, values) => {
        if (!errors) {
          this.setState({ loading: true })
          const { memberPhone, country, ...resetValue } = values
          const mobileNo = `${country}-${memberPhone}`
          resetValue.mobileNo = mobileNo
          this.props.submit({ ...resetValue, method: 'MESSAGE_PAY' }).then(() => {
            this.setState({ loading: false })
          })
        }
      })
    }

    handlePhoneChange = () => {
      const { form } = this.props
      setTimeout(() => {
        form.validateFields(['memberPhone'], (err) => {
          this.setState({
            available: !err,
          })
        })
      }, 100)
    }

    render() {
      const { siteConfig, form } = this.props
      return (
        <React.Fragment>
          <Helmet>
            <title>{intl().formatMessage(messages.title)}</title>
          </Helmet>
          <Flex.Item className={classes.paymentsMessagePay}>
            <WhiteSpace />
            <WhiteSpace />
            <div className='text-center green'>
              <img width={100} src={require('./images/logo.png')} />
              <WhiteSpace size='sm' />
              <div>
                <b>
                  <FormattedMessage {...messages.p1} />
                </b>
              </div>
              <div>
                <b>
                  <FormattedMessage {...messages.title} />
                </b>
              </div>
            </div>
            <WhiteSpace />
            <WhiteSpace />
            <WingBlank>
              <Form>
                {form.getFieldDecorator('orderToken', {
                  initialValue: this.state.orderToken,
                })(<Input className='hidden' />)}
                <PhoneInput
                  form={form}
                  siteConfig={siteConfig}
                  resetError={() => {
                    setTimeout(() => {
                      form.validateFields(['memberPhone'], (err, values) => {
                        this.setState({
                          available: !err,
                        })
                      })
                    }, 100)
                  }}
                  removeCaptcha={this.props.removeCaptcha}
                />
                <Captcha form={form} />
                {/* eslint-disable-next-line react/jsx-pascal-case */}
                <OTP form={form} available={this.state.available} eventType='PAYPAGE_LOGIN' required={['memberPhone', 'country', 'captcha']} type='message_pay' />
                <WhiteSpace size='xl' />
                <Button type='primary' block size='large' loading={this.state.loading} onClick={this.handleSubmit}>
                  <FormattedMessage {...messages.btn} />
                </Button>
              </Form>
              <WhiteSpace />
            </WingBlank>
          </Flex.Item>
        </React.Fragment>
      )
    }
}

export default connect(
  (state) => ({
    siteConfig: state.siteConfig,
  }),
  {
    removeCaptcha,
  }
)(Form.create()(MessagePay))
